"use client";
import PageContent from "./PageContent";
import { PageTypes } from "@lib/enums/PageTypes";
import { DefaultLayout } from "@app/DefaultLayout";
import { ErrorPageContent } from "@components/errors/ErrorPageContent";
import { useGlobalContent } from "@app/[locale]/GlobalContentProvider";
/*
The error.tsx page has to be a client component and as such cannot fetch data on the server.
Instead we fetch it from an API route.
*/
export default function ErrorPage() {
    const { siteSettings } = useGlobalContent();

    if (!siteSettings) {
        return <ErrorPageContent />;
    }

    return (
        <PageContent pageType={PageTypes.ERROR}>
            <DefaultLayout>
                <ErrorPageContent />
            </DefaultLayout>
        </PageContent>
    );
}
